import { render, staticRenderFns } from "./PanelBlueContainer.vue?vue&type=template&id=82d2ca9a&scoped=true&"
import script from "./PanelBlueContainer.vue?vue&type=script&lang=js&"
export * from "./PanelBlueContainer.vue?vue&type=script&lang=js&"
import style0 from "./PanelBlueContainer.vue?vue&type=style&index=0&id=82d2ca9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82d2ca9a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
